define("auth/controllers/trial-plans", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking"], function (_exports, _controller, _object, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TrialPlansController = (_class = class TrialPlansController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "onboarding", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _defineProperty(this, "trialOptInPlans", []);

      _initializerDefineProperty(this, "trialDismissed", _descriptor5, this);

      _initializerDefineProperty(this, "selectedPlan", _descriptor6, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get shouldShowNotNowButtonTop() {
      var _this$currentAccount$;

      return ((_this$currentAccount$ = this.currentAccount.experiments) === null || _this$currentAccount$ === void 0 ? void 0 : _this$currentAccount$['web_onboarding_trial-opt-in']) === 'not-now-button-top';
    }

    get startTrialButtonClass() {
      return "selected--".concat(this.selectedPlan);
    }

    selectPlan(planType) {
      this.selectedPlan = planType;
    }

    goToPlan(planType) {
      this.router.transitionTo('plans.plan', planType, {
        queryParams: {
          isMonthly: true,
          isTrialOptInAtSignup: true,
          isTrialOptInFromCalendar: false
        }
      });
    }

    handlePlanButtonClick(planType) {
      this.router.transitionTo('plans.plan', planType, {
        queryParams: {
          isMonthly: true,
          isTrialOptInAtSignup: true
        }
      });
    }

    dismissTrial() {
      var _this$auth$currentGro;

      this.segment.track('declined-trial-offer', {
        area: 'opt_in_modal'
      });
      this.router.transitionTo('cluster.schedule.calendar', (_this$auth$currentGro = this.auth.currentGroup) === null || _this$auth$currentGro === void 0 ? void 0 : _this$auth$currentGro.slug);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "trialDismissed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "selectPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePlanButtonClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePlanButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissTrial"), _class.prototype)), _class);
  _exports.default = TrialPlansController;
});